import React from 'react';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../shared/packages/searchParamsManager';
import { booleanMap } from '../../shared/configs/searchParams';
import SwitchLabel from '../../shared/ui/SwitchLabel';

const ToggleBoolSearchParam = ({
  searchParamKey,
  label,
  className,
  getUpdatedSearchParams,
  onChange,
  labelPos,
  switchClassName,
  ...props
}) => {
  const value = useSearchParamsSelector((state) => {
    return state[searchParamKey];
  });

  const { setParams } = useSearchParamsMethods();

  const handleChange = (checked) => {
    setParams({
      [searchParamKey]: checked ? booleanMap.yes : booleanMap.no,
      ...(typeof getUpdatedSearchParams === 'function' &&
        getUpdatedSearchParams(checked)),
    });

    typeof onChange === 'function' && onChange(checked);
  };

  return (
    <SwitchLabel
      {...props}
      switchClassName={switchClassName}
      labelPos={labelPos}
      className={className}
      checked={value === booleanMap.yes}
      label={label}
      onChange={handleChange}
    />
  );
};

export default ToggleBoolSearchParam;
